<div class="col-12">
  <h1 class="h1-responsive">{{title}} List</h1>
  <dac-asset-list [type]="assetType" (selected)="viewAsset($event)"></dac-asset-list>
</div>


// WEBPACK FOOTER //
// ./src/app/library-assets/exercise-list/exercise-list.component.html